import actions from '@/core/store/ata/actions'
import getters from '@/core/store/ata/getters'
import mutations from '@/core/store/ata/mutations'
import state from '@/core/store/ata/state'
import acompanhamento from '@/core/store/ata/acompanhamento'
import documentosAta from '@/core/store/ata/documentos-ata'
import gestaoPedido from '@/core/store/ata/gestao-pedido'
import pesquisa from '@/core/store/ata/pesquisa'
import gestaoAta from '@/core/store/ata/gestao-ata'
import fiscais from '@/core/store/ata/fiscais'
import controleSaldosOrgao from '@/core/store/ata/controle-saldos-orgao'

export default {
	actions,
	getters,
	mutations,
	state,
	modules: {
		documentosAta,
		gestaoPedido,
		acompanhamento,
		pesquisa,
		gestaoAta,
		fiscais,
		controleSaldosOrgao,
	},
}
